import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {Box, CircularProgress, Dialog, DialogContent} from "@mui/material";
/*import {ReactComponent as Logo} from "../../images/logo.svg"*/

type props = {
  error: boolean
}

export default NiceModal.create(({error}: props) => {
  const modal = useModal();
  return (
    <Dialog open={modal.visible}>
      <DialogContent>
        {error
          ? <>
            <h3>Beklager, bestilling ikke mulig</h3>
            <p>Vi har gjennomført kredittvurdering basert på data og beslutningsmodell hos vår samarbeidspartner innen kredittvurdering.</p>
            <p>Resultatet av denne gjør at vi dessverre ikke kan tilby deg Forutsigbar betaling.</p>
            <p>Dersom du har registrert frivillig kredittsperre, så kan ikke vi foreta kredittvurdering. Du kan i så tilfelle oppheve kredittsperren på samme sted som du opprettet den, og så forsøke å bestille Forutsigbar Betaling på nytt.</p>
            <p>Ta gjerne kontakt med Steddi kundeservice dersom du har noen spørsmål, du når oss på 55 90 73 50.</p>
          </>
          : <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <h3>Vi forbereder signeringen, ikke lukk vinduet</h3>
            <div style={{position: "relative"}}>
              {/*<Logo style={{height: "50px", fill: "#2D0067", position: "absolute", top: 0, left: 5, right: 0, bottom: 5, margin: "auto"}} />*/}
              <CircularProgress size={70}/>
            </div>
          </Box>}
      </DialogContent>
    </Dialog>
  )
})